import { translate } from "app/filters/i18nFilter";
import { OpportunityListTypeEnum } from "app/pages/sales-intelligence/sub-modules/opportunities/types";

import type { ListItemDto } from "../../types/dto";

export const getListTitle = ({ listType, listName }: ListItemDto): string => {
    if (listType === OpportunityListTypeEnum.RecentlyViewed) {
        return translate("si.opportunity-list.auto-created.title");
    }
    return listName;
};
